import linkifyHtml from "linkify-html";

document.addEventListener("DOMContentLoaded", () => {
    const linkTargets = document.querySelectorAll(".js-linkify");
    linkTargets.forEach((element) => {
        const originalHtml = element.innerHTML;
        element.innerHTML = linkifyHtml(originalHtml, {
            target: "_blank",
        });
    });
});
